const listingVideoTypes = {
  UPDATE_PUPPY_VIDEO_ViSIBILITY: 'UPDATE_PUPPY_VIDEO_ViSIBILITY',
  UPDATE_PUPPY_MEDIA_IMAGE_AFTER_EDIT: 'UPDATE_PUPPY_MEDIA_IMAGE_AFTER_EDIT',
  UPDATE_PARENT_MEDIA_IMAGE_AFTER_EDIT: 'UPDATE_PARENT_MEDIA_IMAGE_AFTER_EDIT',
  ERROR_MEDIA_IMAGE_AFTER_EDIT: 'ERROR_MEDIA_IMAGE_AFTER_EDIT',
  PUPPY_MEDIA_UPDATE: 'PUPPY_MEDIA_UPDATE',
  ADD_NEW_MEDIA_ITEM: 'ADD_NEW_MEDIA_ITEM',
  ADD_NEW_LITTER_MEDIA_ITEM: 'ADD_NEW_LITTER_MEDIA_ITEM',
  UPDATE_LITTER_MEDIA_IMAGE_AFTER_EDIT: 'UPDATE_LITTER_MEDIA_IMAGE_AFTER_EDIT',
};

export default listingVideoTypes;
